import React from 'react';
import authRoute from './authRoute';
import siteRoutes from './siteRoutes';
import checkoutRoute from './checkoutRoute';
import { ADMIN, MANAGER, DOCTOR, USER } from 'constants/roles.constant';

export const publicRoutes = [...authRoute, ...siteRoutes, ...checkoutRoute];

export const protectedRoutes = [
  {
    key: 'adminList',
    path: '/admin/admins',
    component: React.lazy(() => import('views/admin/AdminList/index')),
    authority: [ADMIN],
  },
  {
    key: 'createAdmin',
    path: '/admin/admins/criar',
    component: React.lazy(() => import('views/admin/CreateAdmin/index')),
    authority: [ADMIN],
  },
  {
    key: 'editAdmin',
    path: '/admin/admins/:id',
    component: React.lazy(() => import('views/admin/EditAdmin/index')),
    authority: [ADMIN],
  },

  {
    key: 'doctorList',
    path: '/admin/medicos',
    component: React.lazy(() => import('views/admin/DoctorList/index')),
    authority: [ADMIN, MANAGER],
  },
  {
    key: 'createDoctor',
    path: '/admin/medicos/criar',
    component: React.lazy(() => import('views/admin/CreateDoctor/index')),
    authority: [ADMIN, MANAGER],
  },
  {
    key: 'editDoctor',
    path: '/admin/medicos/:id',
    component: React.lazy(() => import('views/admin/EditDoctor/index')),
    authority: [ADMIN, MANAGER],
  },

  {
    key: 'patientList',
    path: '/admin/pacientes',
    component: React.lazy(() => import('views/admin/PatientList/index')),
    authority: [ADMIN, MANAGER, DOCTOR],
  },
  {
    key: 'createPatient',
    path: '/admin/paciente/criar',
    component: React.lazy(() => import('views/admin/CreatePatient/index')),
    authority: [ADMIN, MANAGER],
  },
  {
    key: 'editPatient',
    path: '/admin/paciente/:id',
    component: React.lazy(() => import('views/admin/EditPatient/index')),
    authority: [ADMIN, MANAGER],
  },
  {
    key: 'patienttDetails',
    path: '/admin/detalhes-paciente/:id',
    component: React.lazy(() => import('views/admin/PatientDetails')),
    authority: [ADMIN, MANAGER, DOCTOR, USER],
  },

  {
    key: 'appointmentList',
    path: '/admin/consultas',
    component: React.lazy(() => import('views/admin/AppointmentList')),
    authority: [ADMIN, MANAGER, DOCTOR, USER],
  },
  {
    key: 'appointmentDetails',
    path: '/admin/consultas/:id',
    component: React.lazy(() => import('views/admin/AppointmentDetails')),
    authority: [ADMIN, MANAGER, DOCTOR, USER],
  },

  {
    key: 'specialtiesList',
    path: '/admin/especialidades',
    component: React.lazy(() => import('views/admin/SpecialtiesList')),
    authority: [ADMIN, MANAGER],
  },
  {
    key: 'createPatient',
    path: '/admin/especialidades/criar',
    component: React.lazy(() => import('views/admin/CreateSpecialty')),
    authority: [ADMIN, MANAGER],
  },
  {
    key: 'editSpecialty',
    path: '/admin/especialidades/:id',
    component: React.lazy(() => import('views/admin/EditSpecialty')),
    authority: [ADMIN, MANAGER],
  },

  {
    key: 'virtualRoom',
    path: '/admin/forum',
    component: React.lazy(() => import('views/admin/VirtualRoomList/index')),
    authority: [ADMIN, MANAGER, DOCTOR],
  },
  {
    key: 'editVirtualRoom',
    path: '/admin/forum/:id',
    component: React.lazy(() => import('views/admin/VirtualRoomDetails/index')),
    authority: [ADMIN, MANAGER, DOCTOR],
  },
  {
    key: 'editVirtualRoom',
    path: '/admin/forum/criar',
    component: React.lazy(() => import('views/admin/CreateVirtualRoom/index')),
    authority: [ADMIN, MANAGER, DOCTOR],
  },

  {
    key: 'configs',
    path: '/admin/configuracoes',
    component: React.lazy(() => import('views/admin/Settings/index')),
    authority: [ADMIN, MANAGER, DOCTOR, USER],
  },
  {
    key: 'notifications',
    path: '/admin/notifications',
    component: React.lazy(() => import('views/admin/Notifications/index')),
    authority: [ADMIN, MANAGER, DOCTOR, USER],
  },
];
